<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment";
// eslint-disable-next-line no-unused-vars
import NumerosaLetras from "../../../../helpers/numeros";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";

/**
 * Products component
 */
// eslint-disable-next-line no-unused-vars
export default {
  page: {
    title: "Product",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      formPro: {
        direccionp: "",
        empleado: "",
        nit_cliente: "",
        no_orden: "",
        observaciones: "",
        fecha_compra: "",
        tienda: "",
        cliente: "",
        dias_vencimiento: "",
        totalPendiente: 0,
        totalPagado: 0,
        vendedor: "",
        total: "",
        state: true,
        id: 0,
      },
      estadoCredito: false,
      formFactura: {
        fecha_emision: "",
        fecha_certificacion: "",
        dataCert: "",
        serie: "",
        number: "",
        uuid: "",
      },
      detalleorden: [],
      title: "IMPRIMIR",
      items: [
        {
          text: "Cotización",
          href: "/",
        },
        {
          text: "Imprimir cotización",
          active: true,
        },
      ],
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.detalle();
  },
  updated() {
    this.$refs["buttonImprimir"].click();
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    letras(cantidad) {
      let a;
      a = NumerosaLetras(cantidad);
      return a;
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    quantity(value) {
      return parseFloat(value)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMMM DD [de] YYYY");
    },
    showHour(date) {
      return moment(date).locale("es").format("MMM Do YYYY HH:mm");
    },
    detalle() {
      let me = this;
      axios
        .get(
          process.env.VUE_APP_URL +
            "ventas/view_venta?id=" +
            this.$route.params.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          // console.log(response);
          this.formPro.no_ducumento_v = response.data.orden.no_ducumento_v
          this.formPro.fecha_venta_v = response.data.orden.fecha_venta_v
          this.formPro.totalPendiente = response.data.orden.saldo_credito_v
            this.formPro.totalPagado = (parseFloat(response.data.orden.total_v) - parseFloat(response.data.orden.saldo_credito_v)); 
          this.estadoCredito=response.data.orden.estado_credito_v;
          this.formFactura.datCert = response.data.orden.dataCert;
          this.formFactura.serie = response.data.orden.serie;
          this.formFactura.number = response.data.orden.number;
          this.formFactura.uuid = response.data.orden.uuid;
          if (response.data.orden.nit_facturacion != "CF") {
            this.formPro.cliente = response.data.orden.nit_facturacion
              ? response.data.orden.nombre_cliente
              : response.data.orden.cliente.persona.nombre_persona;
            this.formPro.direccionp =
              response.data.orden.cliente.persona.direccion_persona == ""
                ? "Ciudad"
                : response.data.orden.cliente.persona.direccion_persona;
            this.formPro.nit_cliente = response.data.orden.nit_facturacion
              ? response.data.orden.nit_facturacion
              : "CF";
          } else {
            this.formPro.cliente = response.data.orden.nombre_cliente;
            this.formPro.direccionp =
              response.data.orden.cliente.persona.direccion_persona != ""
                ? response.data.orden.cliente.persona.direccion_persona
                : "Ciudad";
            this.formPro.nit_cliente = "CF";
          }
          this.formPro.vendedor =
            response.data.orden.user.empleado.persona.nombre_persona +
            " " +
            response.data.orden.user.empleado.persona.apellido_persona;
          this.formPro.total =
            response.data.orden.estado_cuenta == true
              ? parseFloat(response.data.orden.total_v) +
                parseFloat(response.data.orden.pago_cuenta)
              : response.data.orden.total_v;
          this.formPro.no_orden = response.data.orden.no_venta;
          let detalleProducto = response.data.orden.detalle_ventas;
          let detalleServicio = response.data.orden.detalle_servicio_vs;
          // console.log(detalleProducto, detalleServicio);
          if (detalleProducto) {
            for (let i = 0; i < detalleProducto.length; i++) {
              me.detalleorden.push({
                cantidad: detalleProducto[i].cantidad_venta,
                descripcion:
                  detalleProducto[i].producto.nombre_producto +
                  (detalleProducto[i].producto.descripcion_producto ==
                    null ||
                  detalleProducto[i].producto.descripcion_producto == ""
                    ? ""
                    : " - " +
                      detalleProducto[i].producto.descripcion_producto),
                valor_unitario: detalleProducto[i].precio_venta,
                subtotal: detalleProducto[i].subtotal_venta,
              });
            }
          }

          if (detalleServicio) {
            for (let i = 0; i < detalleServicio.length; i++) {
              me.detalleorden.push({
                cantidad: detalleServicio[i].cantidad_servicios,
                descripcion:
                  detalleServicio[i].servicio.nombre_servicio +
                  (detalleServicio[i].servicio.descripcion_servicio == "" ||
                  detalleServicio[i].servicio.descripcion_servicio == null
                    ? ""
                    : " - " + detalleServicio[i].servicio.descripcion_servicio),
                valor_unitario: detalleServicio[i].precio_servicio,
                subtotal: detalleServicio[i].subtotal_servicio,
              });
            }
          }
        });
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
  },
};
</script>
<style></style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row mt-4">
      <div class="col d-print-none">
        <router-link
          :to="{
            name: 'ventas',
          }"
          class="btn text-muted d-none d-sm-inline-block btn-link"
        >
          <i class="mdi mdi-arrow-left me-1"></i>REGRESAR
        </router-link>
      </div>
      <div class="col d-print-none">
        <div class="float-end">
          <a
            ref="buttonImprimir"
            href="javascript:window.print()"
            class="btn btn-primary w-md waves-effect waves-light me-1"
            ><i class="fa fa-print"></i>&nbsp;&nbsp;IMPRIMIR</a
          >
        </div>
      </div>
    </div>
    <!-- end row -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="watermark">
          <div class="card-body">
           
            <br />
            <div class="row">
        <div class="col d-flex justify-content-center">
            <img class="img-fluid" style="max-width: 150px;" src="../../../../../src/assets/logo.png" alt="Logo" />
        </div>
        <div class="col text-right"> <!-- Ajuste aquí -->
            <h6>Sociedad Anonima</h6>
            <label><i class="bx bx-phone"></i>2342 2342 234234</label><br />
            <label><i class="bx bx-map"></i>Entrada Principal de comapa Jutiapa<br /></label><br />
        </div>
        <div class="col text-right"> <!-- Ajuste aquí -->
            <h6>Usuario: {{ formPro.vendedor }} </h6>
            <label><i class="bx bx-phone"></i>No. Venta {{ formPro.no_ducumento_v }}</label><br />
            <label><i class="bx bx-map"></i>Fecha {{ formPro.fecha_venta_v }}<br /></label><br />
        </div>
    </div>
            <hr style="color: black" />
            <div class="row">
              
             
              <div class="row">
                <div class="col">
                  <label>Cliente: {{ formPro.cliente }}</label> <br />
               
                </div>
                <div class="col">
                  <label>Dirección: {{ formPro.direccionp }}</label>
                </div>
              </div>
              <hr style="color: black" />
            </div>
            <div>
              <table class="table" border="2" style="font-size: small">
                <thead>
                  <tr>
                    <th>
                      <i class="bx bxs-grid-alt"></i>&nbsp;&nbsp;Descripción
                    </th>
                    <th><i class="bx bx-list-ul"></i>&nbsp;&nbsp;Cantidad</th>
                    <th>
                      <i class="bx bx-purchase-tag-alt"></i>&nbsp;&nbsp;Precio
                      unitario
                    </th>
                    <th><i class="bx bx-money"></i>&nbsp;&nbsp;Monto</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, idx) in detalleorden"
                    v-bind:key="idx"
                    style="font-size: small"
                  >
                  <td>{{ item.descripcion }}</td>
                  <td>{{ quantity(item.cantidad) }} Unidad(es)</td>
                  <td>
                    {{ money(item.valor_unitario) }}
                  </td>
                    <td>
                      {{ money(item.subtotal) }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="row">
                <div class="col" />
                <div class="col" />
                <div class="col" />
                <div class="col">
                  <h4><strong>Total</strong></h4>
                </div>
                <div class="col" align="right">
                  <h4>
                    <strong>
                      {{ money(formPro.total > 0 ? formPro.total : 0.0) }}
                    </strong>
                  </h4>  
                </div>
                <div class="col" v-if="estadoCredito">
                  <h4><strong>Pendiente:</strong></h4>
                </div>
                <div class="col" align="right" v-if="estadoCredito">
                  <h4>
                    <strong>
                  {{ money(formPro.totalPendiente) }}
                    </strong>
                  </h4>  
                </div>
                <div class="col" v-if="estadoCredito">
                  <h4><strong>Adelanto:</strong></h4>
                </div>
                <div class="col" align="right" v-if="estadoCredito">
                  <h4>
                    <strong>
                      {{ money(formPro.totalPagado) }}
                    </strong>
                  </h4>  
                </div>


              </div>
              <br />
              <div class="row">
                <h6>
                  <strong> Valor en letras: </strong>{{ letras(formPro.total) }}
                </h6>

                <br />
                <p align="justify">
                  IMPORTANTE: Apreciable cliente en repuestos no se
                  aceptan cambios ni devoluciones. Para cambios y devoluciones
                  de otros artículos o productos es de 3 días hábiles, deberá
                  presentar su factura o comprobante de compra, el producto debe
                  encontrarse en las mismas condiciones en que fue entregado.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.fondo {
  background-color: #f05948;
}
/*
@media print {
  @page {
    margin: 10px;
    size: auto;
  }
}*/
</style>
